import { Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';

export const routes: Routes = [
  {
    path: 'start',
    children: [
      { path: '', component: HomeComponent },
      { path: ':id', component: HomeComponent },
    ],
  },
  {
    path: 'chat',
    loadComponent: () =>
      import('./chat/chat.component').then((m) => m.ChatComponent),
  },
  {
    path: 'overview',
    loadComponent: () =>
      import('./product-overview/product-overview.component').then(
        (m) => m.ProductOverviewComponent,
      ),
  },
  {
    path: 'verification',
    loadComponent: () =>
      import(
        './phone-code-verification/phone-code-verification.component'
      ).then((m) => m.PhoneCodeVerificationComponent),
  },
  {
    path: 'contract',
    loadComponent: () =>
      import('./read-contract/read-contract.component').then(
        (m) => m.ReadContractComponent,
      ),
  },
  {
    path: 'pre-scan',
    loadComponent: () =>
      import('./scan-tutorial/scan-tutorial.component').then(
        (m) => m.ScanTutorialComponent,
      ),
  },
  {
    path: 'scan',
    loadComponent: () =>
      import('./scan/scan.component').then((m) => m.ScanComponent),
  },
  {
    path: 'exit',
    loadComponent: () =>
      import('./exit-screen/exit-screen.component').then(
        (m) => m.ExitScreenComponent,
      ),
  },
  { path: '**', redirectTo: 'start' },
];
